var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWorldwide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#71E3E2",
    strokeWidth: 5,
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 48,
    cy: 48,
    rx: 24,
    ry: 48
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M48 0v96M0 48h96M7.68 24.96H88.8M7.68 71.04H88.8"
  }))));
}

export default SvgWorldwide;